import { Row, Col, FormGroup, Label, Button, Input } from "reactstrap";
import { useDataFetch } from "../../Hooks/Use-data-fetch";
import Select from "react-select";
import { useState, useEffect } from "react";

export const UserFilters = ({ filters, setFilters, onSearch }) => {
  const { getData } = useDataFetch();

  const [searchTerm, setSearchTerm] = useState("");
  const [finalSearch, setFinalSearch] = useState("");

  useEffect(() => {
    const timeout = setTimeout(() => {
      setFinalSearch(searchTerm.trim());
    }, 600);
    return () => clearTimeout(timeout);
  }, [searchTerm]);


  const { data: usersData, isPending: loadingUsers } = getData(
    ["users", finalSearch],
    "/users/all",
    { enabled: finalSearch.length >= 3 },
    { search: finalSearch }
  );

  const { data: countriesData, isPending: loadingCountries } = getData(
    ["countries"],
    "/product/all/countries"
  );

  const users = usersData?.data?.users || [];

  const sponsorOptions = users.map((user) => ({
    value: user.multyhealth_code,
    label: user.document
      ? `${user.multyhealth_code} - ${user.document} - ${user.name}`
      : `${user.multyhealth_code} - ${user.name}`,
  }));

  const countryOptions =
    countriesData?.data?.countries?.map((c) => ({
      value: c.id,
      label: c.name,
    })) || [];

  const customSelectStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "30px",
      height: "30px",
      fontSize: "0.875rem",
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: "30px",
      padding: "0 8px",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "30px",
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: "0.875rem",
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: "0.875rem",
    }),
  };

  return (
    <Row className="gx-3 gy-2 align-items-end w-100">
      {/* Código */}
      <Col xs="12" sm="6" md="4" lg="2">
        <FormGroup className="mb-0">
          <Label className="form-label mb-1">Código</Label>
          <Input
            type="text"
            bsSize="sm"
            value={filters.code}
            onChange={(e) =>
              setFilters((prev) => ({ ...prev, code: e.target.value }))
            }
          />
        </FormGroup>
      </Col>

      {/* Documento */}
      <Col xs="12" sm="6" md="4" lg="2">
        <FormGroup className="mb-0">
          <Label className="form-label mb-1">Documento</Label>
          <Input
            type="text"
            bsSize="sm"
            value={filters.document}
            onChange={(e) =>
              setFilters((prev) => ({ ...prev, document: e.target.value }))
            }
          />
        </FormGroup>
      </Col>

      {/* Nombre */}
      <Col xs="12" sm="6" md="4" lg="2">
        <FormGroup className="mb-0">
          <Label className="form-label mb-1">Nombre</Label>
          <Input
            type="text"
            bsSize="sm"
            value={filters.name}
            onChange={(e) =>
              setFilters((prev) => ({ ...prev, name: e.target.value }))
            }
          />
        </FormGroup>
      </Col>

      {/* Auspiciador */}
      <Col xs="12" sm="6" md="6" lg="2">
        <FormGroup className="mb-0">
          <Label className="form-label mb-1">Código Auspiciador</Label>
          <Select
            options={finalSearch.length >= 3 ? sponsorOptions : []}
            isClearable
            isLoading={finalSearch.length >= 3 && loadingUsers}
            placeholder="Escribe al menos 3 caracteres"
            className="react-select-sm"
            classNamePrefix="react-select"
            styles={customSelectStyles}
            onInputChange={(val, { action }) => {
              if (action === "input-change") setSearchTerm(val);
            }}
            value={
              sponsorOptions.find(
                (opt) => opt.value === filters.sponsorCode
              ) || null
            }
            onChange={(selected) =>
              setFilters((prev) => ({
                ...prev,
                sponsorCode: selected?.value || "",
              }))
            }
            noOptionsMessage={() =>
              searchTerm.length < 3
                ? "Escribe al menos 3 caracteres"
                : "No se encontraron resultados"
            }
          />
        </FormGroup>
      </Col>

      {/* País */}
      <Col xs="12" sm="6" md="6" lg="2">
        <FormGroup className="mb-0">
          <Label className="form-label mb-1">País</Label>
          <Select
            options={countryOptions}
            isClearable
            isLoading={loadingCountries}
            placeholder="Selecciona país"
            className="react-select-sm"
            classNamePrefix="react-select"
            styles={customSelectStyles}
            value={
              countryOptions.find((opt) => opt.value === filters.countryId) ||
              null
            }
            onChange={(selected) =>
              setFilters((prev) => ({
                ...prev,
                countryId: selected?.value || "",
              }))
            }
          />
        </FormGroup>
      </Col>

      {/* Botón Buscar */}
      <Col xs="12" sm="6" md="6" lg="1">
        <FormGroup className="mb-0">
          <Label className="form-label mb-1 d-block">&nbsp;</Label>
          <Button color="primary" size="sm" className="w-100" onClick={onSearch}>
            <i className="ri-search-line me-1" />
            Buscar
          </Button>
        </FormGroup>
      </Col>
    </Row>
  );
};
